import Vue from "vue";

export const WarrantyEventBus = new Vue();
